module.exports = __webpack_public_path__ + "static/PAGOS-7418477deec5ed68fbd7b7fcd65655d5.svg";